export default __webpack_public_path__ + "static/media/odyseeLogo.94b50907.svg";